var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecurrentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13.3889L6.287 17.5399L9.492 13.7029",
    stroke: "#1D1D26",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4998 17.7019L23.7138 13.5509L20.5078 17.3879",
    stroke: "#1D1D26",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6768 14.0419C24.015 16.1849 23.5327 18.3766 22.3262 20.1798C21.1198 21.9829 19.2778 23.2649 17.1678 23.7699C15.7654 24.1012 14.3017 24.0706 12.9144 23.6809C11.527 23.2911 10.2615 22.5551 9.23682 21.5419",
    stroke: "#1D1D26",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29185 16.9829C6.00867 15.8473 5.95348 14.6669 6.12947 13.5098C6.30546 12.3528 6.70915 11.2422 7.31716 10.2422C7.92518 9.24217 8.72546 8.37266 9.6717 7.68396C10.6179 6.99526 11.6914 6.50103 12.8298 6.22987C14.3264 5.87498 15.8913 5.93323 17.3573 6.39837C18.8234 6.86351 20.1356 7.7181 21.1538 8.87087",
    stroke: "#1D1D26",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurrentIcon);
export default __webpack_public_path__ + "static/media/recurrent-icon.25d9dedfc6c1dc1c5c0055c8353a58a5.svg";
export { ForwardRef as ReactComponent };